import { useEffect, useState } from "react";
import { getWaiverTemplates } from "../../api/historyService";

export const useWaiverTemplates = (trigger, emptyCallback) => {
  // Always start with an empty array, not {}
  const [waiverTemplates, setWaiverTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true); // reset loading when trigger changes
    getWaiverTemplates()
      .then((res) => {
        // Normalize: ensure categories.data is always an array
        setWaiverTemplates(Array.isArray(res.data) ? res.data : []);
        if (emptyCallback && res.data.length === 0) emptyCallback(true);
      })
      .catch((error) => {
        console.error("Failed to fetch waiver templates:", error);
        setWaiverTemplates([]); // fallback to empty array
      })
      .finally(() => {
        setLoading(false);
      });
  }, [trigger]);

  return { waiverTemplates, loading, setWaiverTemplates };
};